import { Observable, of } from 'rxjs';
import { ConsentsTranslations } from '@app/shared/models/consents-translations';
import { map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SettingsService } from '@app/core/settings/settings.service';
import { Resolve } from '@angular/router';

export interface ConsentsData {
  isConsentAvailable: boolean;
  containsIdentifiers: boolean;
  consentsTranslations: ConsentsTranslations | null;
}

@Injectable({
  providedIn: 'root',
})
export class ConsentsDataResolver implements Resolve<ConsentsData> {

  constructor(private settingsService: SettingsService) {}

  public resolve(): Observable<ConsentsData> {
    return this.settingsService.getSettingsOnce().pipe(
      map(settings => ({
        isConsentAvailable: !!Object.keys(settings.schema.consents || []).length && !!settings.schema.identifiers,
        settings,
      })),
      switchMap(({
                   isConsentAvailable,
                   settings,
                 }) => ((isConsentAvailable ? this.settingsService.getConsentTranslations() : of(null)) as Observable<ConsentsTranslations | null>).pipe(
        map((consentsTranslations: ConsentsTranslations | null) => ({
            isConsentAvailable,
            consentsTranslations,
            containsIdentifiers: !!settings.schema.identifiers,
          }),
        ),
      )),
    );
  }

}

